import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// `/next` has no page of its own: it opens on the page `/` sends the user to, which the reroute moves below `/next`.
// The layout above lets in only Internal users, and the page checks its own access, so this route asks for no more.
export const Route = createFileRoute('/_authenticated/next/')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/', replace: true });
    },
});
